<template>
  <div>
    <el-dialog
      :modal-append-to-body="false"
      title="Contrainte(s) fournisseur(s) non respectée(s)"
      :visible.sync="isVisible"
      width="30%"
      @closed="invisible()">
      <div v-for="constraint in orderConstraint" v-bind:key="constraint.msg"
           class="constraint--container">
        <span class="constraint--container--suplier"> {{constraint.supplier}}</span>
        <span> Minimum de commande non respecté </span>
      </div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      orderConstraint: {},
      isVisible: Boolean,
    },
    methods: {
      invisible() {
        this.isVisible = false;
        this.$emit('closedFranco');
      },
    },
  };
</script>

<style lang="stylus">
  .constraint--container {
    display flex
    flex-direction column
  }

  .constraint--container--suplier {
    color #2a8eec
  }
</style>
